import { supabase } from '@/lib/supabase';

export async function logAudit(
  userId: string,
  action: string,
  entity: string,
  entityId?: string,
  oldData?: object,
  newData?: object
) {
  await supabase.from('audit_logs').insert({
    user_id: userId,
    action,
    entity,
    entity_id: entityId ?? null,
    old_data: oldData ?? null,
    new_data: newData ?? null,
  });
}
